import {
  blackBase,
  contrast,
  shade,
  whiteBase,
} from '@mentimeter/ragnar-colors';

const SHADE_COLOR = 'black';

export const getAdjustedPinColor = (
  visualizationColor: string,
  numberOfPinsPercentile: number,
) => {
  const mixValue = numberOfPinsPercentile - 0.5;
  const shadedPinColor = shade(visualizationColor, SHADE_COLOR, mixValue);
  const contrastToWhite = contrast(shadedPinColor, whiteBase);
  const textColor = contrastToWhite > 4.5 ? whiteBase : blackBase;

  return {
    adjustedPinColor: shadedPinColor,
    textColor,
  };
};
